"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateProvider = void 0;
var state_manager_1 = require("@idp/state-manager");
var event_bus_1 = require("@idp/event-bus");
var localdatastore_1 = require("../config/localdatastore");
var app_shell_model_1 = require("@idse/common-ui/models/store/app-shell.model");
var StateProvider = /** @class */ (function () {
    function StateProvider() {
    }
    StateProvider.getStateManagerInstance = function () {
        if (StateProvider.stateManagerInstance) {
            return StateProvider.stateManagerInstance;
        }
        state_manager_1.StateManager.setup(new state_manager_1.SessionDataStore(), event_bus_1.ICCEventBusManager.getInstance());
        StateProvider.stateManagerInstance = state_manager_1.StateManager.buildStateProxyForNamespace(localdatastore_1.getNamespace('CART'));
        return StateProvider.stateManagerInstance;
    };
    StateProvider.getStateManagerInstanceWithAPPShellNameSpace = function () {
        if (StateProvider.appShellStateManagerInstance) {
            return StateProvider.appShellStateManagerInstance;
        }
        state_manager_1.StateManager.setup(new state_manager_1.SessionDataStore(), event_bus_1.ICCEventBusManager.getInstance());
        StateProvider.appShellStateManagerInstance = state_manager_1.StateManager.buildStateProxyForNamespace(localdatastore_1.getNamespace('APPSHELL'), app_shell_model_1.appShellInitialState);
        return StateProvider.appShellStateManagerInstance;
    };
    return StateProvider;
}());
exports.StateProvider = StateProvider;
//# sourceMappingURL=StateProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/StateProvider.js
// module id = 25
// module chunks = 8